"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthGuard = void 0;
//ANGULAR2 BITS
const core_1 = require("@angular/core");
const router_1 = require("@angular/router");
const token_service_1 = require("./token.service");
const notification_service_1 = require("./notification.service");
//INTERNAL LIBRARY BITS
const permission_service_1 = require("./permission.service");
const bidder_service_1 = require("./bidder.service");
let AuthGuard = class AuthGuard {
    constructor(_auth, _router, _permission, _talk, _bidder) {
        this._auth = _auth;
        this._router = _router;
        this._permission = _permission;
        this._talk = _talk;
        this._bidder = _bidder;
    }
    canActivate(route) {
        let url = route.url[0].path || '';
        let params = '';
        let qParams = '';
        if (route.url[1]) {
            url += '/' + route.url[1];
        }
        if (route.url[2]) {
            params = Number(route.url[2].path);
        }
        if (route.queryParams) {
            qParams = route.queryParams;
        }
        //permission check for admins
        switch (url) {
            case "admin":
                return this.checkAdmin(url, params, qParams);
            case "controlcenter/edit":
                return this.checkBidder(url, params, qParams);
            case "queue":
                return this.checkQueue(url, params);
            case "helm":
                return this.checkHelm(url, params);
            default:
                switch (route.url[0].path) {
                    case "controlcenter":
                        return this.checkControlCenter(url, params, qParams);
                    case "dashboard":
                        return this.checkDashboard(url, params, qParams);
                    default:
                        return this.checkLogin(url, params, qParams);
                }
        }
    }
    checkLogin(url, params, qParams) {
        if (this._auth.verifySession()) {
            return true;
        }
        // Store the attempted URL and params for redirecting
        if (params) {
            url = url + '/' + params;
        }
        this._auth.redirectUrl = url;
        if (params != '')
            this._auth.params = params;
        if (qParams != '')
            this._auth.qParams = qParams;
        // Navigate to the login page with extras
        this._router.navigate(['/login']);
        return false;
    }
    checkAdmin(url, params, qParams) {
        if (this._permission.accessAdminBoard()) {
            return true;
        }
        if (this.checkLogin(url, params, qParams)) {
            this._router.navigate(['/portal']);
        }
        ;
        return false;
    }
    checkBidder(url, params, qParams) {
        if (this._bidder.getBidder(params)) {
            return true;
        }
        if (this.checkLogin(url, params, qParams)) {
            this._router.navigate(['/portal']);
        }
        ;
        return false;
    }
    checkControlCenter(url, params, qParams) {
        if (this._permission.get()['control_center-access']) {
            return true;
        }
        if (this.checkLogin(url, params, qParams)) {
            this._router.navigate(['/portal']);
        }
        ;
        return false;
    }
    checkDashboard(url, params, qParams) {
        if (this._permission.get()['dashboard-access']) {
            return true;
        }
        if (this.checkLogin(url, params, qParams)) {
            this._router.navigate(['/portal']);
        }
        ;
        return false;
    }
    checkQueue(url, params) {
        if (this._permission.get()['admin-queue_manager--access']) {
            return true;
        }
        if (this.checkLogin(url, params, '')) {
            this._router.navigate(['/portal']);
        }
        ;
        return false;
    }
    checkHelm(url, params) {
        if (this._permission.get()['helm-access']) {
            return true;
        }
        if (this.checkLogin(url, params, '')) {
            this._router.navigate(['/portal']);
        }
        ;
        return false;
    }
};
exports.AuthGuard = AuthGuard;
exports.AuthGuard = AuthGuard = __decorate([
    (0, core_1.Injectable)(),
    __metadata("design:paramtypes", [token_service_1.TokenService,
        router_1.Router,
        permission_service_1.PermissionService,
        notification_service_1.NotificationService,
        bidder_service_1.BidderService])
], AuthGuard);
//# sourceMappingURL=auth-guard.service.js.map